export default "__VITE_PUBLIC_ASSET__4b365992__"